import React from 'react';
import Content from './Content';
import Color from './Color';
import Author from './Author';
import Title from './Title';
import Description from './Description';
import Thumbnail from './Thumbnail';
import Fields from './Fields';
import Image from './Image';
import Footer from './Footer';
import Buttons from './Buttons';
class Output extends React.Component {
  render() {
    return(
      <div className="cell">
        <div id="builder-container">
          <form id="embed-builder">
            <div className="embed">
              <div className="embed-content">
                <div className="embed-content-inner">
                  <Content />
                  <Color />
                  <Author />
                  <Title />
                  <Description />
                  <Thumbnail />
                  <Fields />
                  <Image />
                  <Footer />
                  <Buttons />
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    );
  }
}

export default Output;
